<template>
  <div 
    class="  px-10 mt-12">
    <v-layout wrap>
      <v-flex>
        <section>
          
          <div class="color-dark-blue fs-22 font-weight-bold">
            Tambahkan BPB
          </div>

          <v-row
            class="">
            <v-col 
              cols="11"
              class="px-0">
              <v-card 
                flat
                style="background: transparent;">
                <v-card-text>
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <!-- <div
                        class="mb-4">
                        <div 
                          class="body-2 mb-2">
                          Poto Profil
                        </div>

                        <uploadfolder v-if="form.image_url === ''"
                          v-model="upload.image">
                          <div 
                            slot="activator">
                            <v-card 
                              flat
                              width="200"
                              height="200"
                              class="d-flex align-center justify-center cursor-pointer"
                              style="border-radius: 15px;
                                    border: 2px solid #EBEBEB; 
                                    border-style: dashed;">
                              <v-avatar v-if="!process.image"
                                v-ripple
                                tile 
                                width="200"
                                height="200">
                                <v-icon
                                  size="50"
                                  color="#B9B9B9">
                                  mdi-cloud-upload-outline
                                </v-icon>
                              </v-avatar>

                              <v-progress-circular v-else
                                indeterminate
                                :color="set_color">
                              </v-progress-circular>
                            </v-card>
                          </div>
                        </uploadfolder>

                        <v-card v-if="form.image_url !== ''"
                          flat
                          width="200"
                          height="200"
                          class="d-flex align-center justify-center"
                          style="border-radius: 15px;
                                border: 2px solid #EBEBEB; 
                                border-style: dashed;">
                          <v-avatar
                            v-ripple
                            tile 
                            size="200"
                            style="border-radius: 15px;">
                            <v-img 
                              contain
                              width="100%"
                              height="100%"
                              alt="Distributor Amanata" 
                              :src="form.image_url"
                              class="ma-auto"
                              style="border-radius: 15px;">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-avatar>

                          <v-icon 
                            @click="form.image_url = ''"
                            color="red"
                            class="cursor-pointer"
                            style="position: absolute; top: -10px; right: -10px;">
                            mdi-close-circle
                          </v-icon>
                        </v-card>
                      </div> -->

                      <v-row>

                        <v-col
                          cols="12"
                          md="12" class="pt-0">

                          <ValidationProvider
                            name="No Order" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              No Order
                            </div>
      
                            <v-autocomplete
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
      
                              color="#4828a1"
                              placeholder="No Order"
                              v-on:change="changeOrder()"
                              
      
                              
                              :items="order"
                              item-value="id"
                              item-text="number"
                              :item-color="set_color"
      
                              v-model="form.order_id"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-autocomplete>
                          </ValidationProvider>
                        </v-col>
                      </v-row>

                      <div v-if="Object.keys(order_json).length > 0">
                        <v-card flat style="border-radius: 25px; border: 1px solid #E7E7E7;" class="mb-8">
                          <v-card-text>
                            <div class="fs-18 input-label mb-3">
                              Detail Order
                            </div>
        
                            <v-row>
                              <v-col>
                                <div>
                                  <div class="mb-1 input-label">
                                    Nomer Order
                                  </div>
                                  <div class="fs-18 font-weight-bold">
                                    {{ order_json.number }}
                                  </div>
                                </div>
                              </v-col>
                              <v-col>
                                <div>
                                  <div class="mb-1 input-label">
                                    Nama Sales
                                  </div>
                                  <div class="fs-18 font-weight-bold">
                                    {{ order_json.sales_name }}
                                  </div>
                                </div>
                              </v-col>
    
                              <v-col>
                                <div>
                                  <div class="mb-1 input-label">
                                    Nama Customer
                                  </div>
                                  <div class="fs-18 font-weight-bold">
                                    {{ order_json.customer_name }}
                                  </div>
                                </div>
                              </v-col>

                              <v-col>
                                <div>
                                  <div class="mb-1 input-label">
                                    Tanggal Order
                                  </div>
                                  <div class="fs-18 font-weight-bold">
                                    {{ order_json.input_datetime | date }}
                                  </div>
                                </div>
                              </v-col>
                            </v-row>
    
                            <v-row>
                              <v-col>
                                <div class="mb-2">
                                  <div class="mb-1 input-label">
                                    Alamat
                                  </div>
                                  <div class="fs-16 font-weight-bold">
                                    {{ order_json.shipping_address }}
                                  </div>
                                </div>
    
                                <div class="mb-2">
                                  <div class="mb-1 input-label">
                                    Kelurahan
                                  </div>
                                  <div class="fs-16 font-weight-bold">
                                    {{ order_json.shipping_village }}
                                  </div>
                                </div>
                              </v-col>
                              <v-col>
                                <div class="mb-2">
                                  <div class="mb-1 input-label">
                                    Kecamatan
                                  </div>
                                  <div class="fs-16 font-weight-bold">
                                    {{ order_json.shipping_subdistrict }}
                                  </div>
                                </div>
    
                                <div class="mb-2">
                                  <div class="mb-1 input-label">
                                    Kabupaten
                                  </div>
                                  <div class="fs-16 font-weight-bold">
                                    {{ order_json.shipping_city }}
                                  </div>
                                </div>
                              </v-col>
                              <v-col>
                                <div class="mb-2">
                                  <div class="mb-1 input-label">
                                    Provinsi
                                  </div>
                                  <div class="fs-16 font-weight-bold">
                                    {{ order_json.shipping_province }}
                                  </div>
                                </div>
    
                              </v-col>
                              <v-col></v-col>
                              <!-- <v-col>
                                <div>
                                  <div class="mb-1 input-label">
                                    Nama Kelurahan
                                  </div>
                                  <div class="fs-18 font-weight-bold">
                                    {{ items.sales_name }}
                                  </div>
                                </div>
                              </v-col>
    
                              <v-col>
                                <div>
                                  <div class="mb-1 input-label">
                                    Nama Kecamatan
                                  </div>
                                  <div class="fs-18 font-weight-bold">
                                    {{ items.customer_name }}
                                  </div>
                                </div>
                              </v-col>
                              <v-col>
                                <div>
                                  <div class="mb-1 input-label">
                                    Nama Kabupaten
                                  </div>
                                  <div class="fs-18 font-weight-bold">
                                    {{ detail.customer_name }}
                                  </div>
                                </div>
                              </v-col>
                              <v-col>
                                <div>
                                  <div class="mb-1 input-label">
                                    Nama Provinsi
                                  </div>
                                  <div class="fs-18 font-weight-bold">
                                    {{ detail.customer_name }}
                                  </div>
                                </div>
                              </v-col> -->
                            </v-row>
                          </v-card-text>
                        </v-card>

                        <v-card flat style="border-radius: 25px; border: 1px solid #E7E7E7;" class="mt-2 mb-3">
                          <v-card-text class="">
                            <div class="d-flex">
                              <div class="fs-18 input-label pt-4">
                                Detail Produk
                              </div>

                              <div class="ml-auto">
                                <ValidationProvider
                                  name="Jumlah Pengiriman" 
                                  rules="required" 
                                  v-slot="{ errors }">
                                  <!-- <div 
                                    class="fs-15 label-input">
                                    Jumlah Pengiriman
                                  </div> -->
            
                                  <v-autocomplete
                                    v-on:keydown.enter.prevent="save()"
                                    
                                    filled
                                    rounded
                                    dense
                                    solo
            
                                    color="#4828a1"
                                    placeholder="Jumlah Pengiriman"
                                    v-on:change="changeJumlah()"
                                    
            
                                    
                                    :items="[1,2,3,4,5,6,7,8,9]"
                                    item-value="id"
                                    item-text="number"
                                    :item-color="set_color"
            
                                    v-model="form.jumlah_bpb"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;">
                                  </v-autocomplete>
                                </ValidationProvider>
                              </div>
                            </div>
                          </v-card-text>
                        </v-card>

                        <v-card flat style="border-radius: 25px; border: 1px solid #E7E7E7;" class="pb-7 mb-5" v-for="(items, indexs) in form.varian_arr" :key="indexs">
                          <v-card-text>
                            <div class="fs-18 input-label mb-8 font-weight-bold pt-2">
                              BPB Ke-{{ items.bpb_id }}
                            </div>
                            <div v-for="(item, index) in items.varian_arr" :key="index+items.bpb_id">
                              <!-- {{ index+items.bpb_id }} -->
                              <!-- <table width="100%" style="border-bottom: thin solid #E6EFF5;">
                                <thead>
                                  <tr>
                                    <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Nama Barang</th>
                                    <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">No. SKU</th>
                                    <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty</th>
                                    <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty Lusin</th>
                                    <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty Dus</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(item, index) in form.varian_arr" :key="index">
                                    <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_varian_name }}</td>
                                    <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_varian_sku }}</td>
                                    <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_qty_pcs_approved }}</td>
                                    <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_qty_lusin_approved }}</td>
                                    <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_qty_dus_approved }}</td>
                                  </tr>
                                </tbody>
                              </table> -->
                              <v-card flat class="mb-5" style="background: #4828a117; border-radius: 15px;">
                                <v-card-text>
                                  <div class="fs-16 font-weight-bold label-input">
                                    {{ item.varian_name }}
                                  </div>
                                  <div>
                                    <span>Kode SKU</span>: <span>{{ item.varian_sku }}</span>
                                  </div>
                                  <!-- <div>
                                    <span>Harga</span>: <span>{{ item.price | price }}</span>
                                  </div> -->

                                  <v-row class="pt-3 pb-2">
                                    <v-col class="py-0" cols="2">
                                      <div 
                                        class="fs-15 label-input">
                                        Qty
                                      </div>
                                    </v-col>
                                    <v-col class="py-0" cols="3">
                                      <div 
                                        class="fs-15 label-input">
                                        Qty yang akan dikirim
                                      </div>
                                    </v-col>
                                  </v-row>
        
                                  <v-row v-if="item.qty_pcs_approve_warehouse*1 > 0">
                                    <!-- <v-col>
                                      <div class="fs-15 label-input">
                                        Harga
                                      </div>
              
                                      <div class="fs-19 font-weight-bold label-input mt-3">
                                        {{ item.price | price }}
                                      </div>
                                    </v-col> -->
        
                                    <v-col class="py-0" cols="2">
                
                                      <div class="fs-19 font-weight-bold label-input mt-3">
                                        {{ item.qty_pcs_approve_warehouse }} Pcs
                                      </div>
                                      <!-- <div class="fs-15 label-input">
                                        Qty
                                      </div>
              
                                      <v-currency-field
                                        
                                        filled
                                        rounded
                                        dense
                                        solo
                  
                                        color="#4828a1"
                                        placeholder="Qty"
        
                                        
                  
                                        v-model="item.qty"
                                        required
                                        style="border-radius: 10px;">
                                      </v-currency-field> -->
                                    </v-col>
                                    <v-col class="py-0" cols="3">
                                      <ValidationProvider
                                        :name="`Qty Pcs ${item.varian_name}`"
                                        :rules="`required|max_value:${item.qty_pcs_approve_warehouse}|min_value:0`" 
                                        v-slot="{ errors }">
                  
                                        <v-currency-field
                                        
                                          filled
                                          rounded
                                          dense
                                          solo
                    
                                          color="#4828a1"
                                          placeholder="Qty"
                                          suffix="pcs"
                                          v-model="item.qty_pcs_approve"
                                          :error-messages="errors"
                                          required
                                          style="border-radius: 10px;">
                                        </v-currency-field>
                                      </ValidationProvider>
                                    </v-col>
        
                                    <!-- <v-col>
                                      <div class="fs-15 label-input">
                                        Harga Beli
                                      </div>
              
                                      <v-currency-field
                                        
                                        filled
                                        rounded
                                        dense
                                        solo
                  
                                        color="#4828a1"
                                        placeholder="Harga Beli"
                                        
                  
                                        v-model="item.harga_beli"
                                        required
                                        style="border-radius: 10px;">
                                      </v-currency-field>
                                    </v-col>
        
                                    <v-col>
                                      <div class="fs-15 label-input">
                                        PPN Beli
                                      </div>
              
                                      <v-currency-field
                                        
                                        filled
                                        rounded
                                        dense
                                        solo
                  
                                        color="#4828a1"
                                        placeholder="PPN Beli"
                                        
                  
                                        v-model="item.ppn_beli"
                                        required
                                        style="border-radius: 10px;">
                                      </v-currency-field>
                                    </v-col> -->
                                  </v-row>
        
                                  <v-row v-if="item.qty_lusin_approve_warehouse*1 > 0">
                                    <!-- <v-col>
                                      <div class="fs-15 label-input">
                                        Harga
                                      </div>
              
                                      <div class="fs-19 font-weight-bold label-input mt-3">
                                        {{ item.price | price }}
                                      </div>
                                    </v-col> -->
        
                                    <v-col class="py-0" cols="2">
                
                                      <div class="fs-19 font-weight-bold label-input mt-3">
                                        {{ item.qty_lusin_approve_warehouse }} Lusin
                                      </div>
                                      <!-- <div class="fs-15 label-input">
                                        Qty
                                      </div>
              
                                      <v-currency-field
                                        
                                        filled
                                        rounded
                                        dense
                                        solo
                  
                                        color="#4828a1"
                                        placeholder="Qty"
        
                                        
                  
                                        v-model="item.qty"
                                        required
                                        style="border-radius: 10px;">
                                      </v-currency-field> -->
                                    </v-col>
                                    <v-col class="py-0" cols="3">
                                      <ValidationProvider
                                        :name="`Qty Lusin ${item.varian_name}`"
                                        :rules="`required|max_value:${item.qty_lusin_approve_warehouse}|min_value:0`" 
                                        v-slot="{ errors }">
                  
                                        <v-currency-field
                                        
                                          filled
                                          rounded
                                          dense
                                          solo
                    
                                          color="#4828a1"
                                          placeholder="Qty"
                                          suffix="lusin"
                                          
                    
                                          v-model="item.qty_lusin_approve"
                                          :error-messages="errors"
                                          required
                                          style="border-radius: 10px;">
                                        </v-currency-field>
                                      </ValidationProvider>
                                    </v-col>
        
                                    <!-- <v-col>
                                      <div class="fs-15 label-input">
                                        Harga Beli
                                      </div>
              
                                      <v-currency-field
                                        
                                        filled
                                        rounded
                                        dense
                                        solo
                  
                                        color="#4828a1"
                                        placeholder="Harga Beli"
                                        
                  
                                        v-model="item.harga_beli"
                                        required
                                        style="border-radius: 10px;">
                                      </v-currency-field>
                                    </v-col>
        
                                    <v-col>
                                      <div class="fs-15 label-input">
                                        PPN Beli
                                      </div>
              
                                      <v-currency-field
                                        
                                        filled
                                        rounded
                                        dense
                                        solo
                  
                                        color="#4828a1"
                                        placeholder="PPN Beli"
                                        
                  
                                        v-model="item.ppn_beli"
                                        required
                                        style="border-radius: 10px;">
                                      </v-currency-field>
                                    </v-col> -->
                                  </v-row>
        
                                  <v-row v-if="item.qty_dus_approve_warehouse*1 > 0">
                                    <!-- <v-col>
                                      <div class="fs-15 label-input">
                                        Harga
                                      </div>
              
                                      <div class="fs-19 font-weight-bold label-input mt-3">
                                        {{ item.price | price }}
                                      </div>
                                    </v-col> -->
        
                                    <v-col class="py-0" cols="2">
                                      
                                      <div class="fs-19 font-weight-bold label-input mt-3">
                                        {{ item.qty_dus_approve_warehouse }} dus
                                      </div>
                  
                                        
                                      <!-- <div class="fs-15 label-input">
                                        Qty
                                      </div>
              
                                      <v-currency-field
                                        
                                        filled
                                        rounded
                                        dense
                                        solo
                  
                                        color="#4828a1"
                                        placeholder="Qty"
        
                                        
                  
                                        v-model="item.qty"
                                        required
                                        style="border-radius: 10px;">
                                      </v-currency-field> -->
                                    </v-col>
                                    <v-col class="py-0" cols="3">
                                      <ValidationProvider
                                        :name="`Qty Dus ${item.varian_name}`" 
                                        :rules="`required|max_value:${item.qty_dus_approve_warehouse}|min_value:0`" 
                                        v-slot="{ errors }">
                  
                                        <v-currency-field
                                        
                                          filled
                                          rounded
                                          dense
                                          solo
                    
                                          color="#4828a1"
                                          placeholder="Qty"
                                          suffix="dus"
                                          
                    
                                          v-model="item.qty_dus_approve"
                                          :error-messages="errors"
                                          required
                                          style="border-radius: 10px;">
                                        </v-currency-field>
                                      </ValidationProvider>
                                    </v-col>
        
                                    <!-- <v-col>
                                      <div class="fs-15 label-input">
                                        Harga Beli
                                      </div>
              
                                      <v-currency-field
                                        
                                        filled
                                        rounded
                                        dense
                                        solo
                  
                                        color="#4828a1"
                                        placeholder="Harga Beli"
                                        
                  
                                        v-model="item.harga_beli"
                                        required
                                        style="border-radius: 10px;">
                                      </v-currency-field>
                                    </v-col>
        
                                    <v-col>
                                      <div class="fs-15 label-input">
                                        PPN Beli
                                      </div>
              
                                      <v-currency-field
                                        
                                        filled
                                        rounded
                                        dense
                                        solo
                  
                                        color="#4828a1"
                                        placeholder="PPN Beli"
                                        
                  
                                        v-model="item.ppn_beli"
                                        required
                                        style="border-radius: 10px;">
                                      </v-currency-field>
                                    </v-col> -->
                                  </v-row>
        
                                </v-card-text>
                              </v-card>
                            </div>

                          </v-card-text>
                        </v-card>
      
                      </div>
                    </v-form>
                  </ValidationObserver>



                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pt-0 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn 
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="190"
                height="45"
                elevation="0"
                color="#6948c6"
                class="fs-16 white--text text-capitalize border-radius">
                Simpan
              </v-btn>
              
              <v-btn
                to="/delivery/bpb"
                :disabled="process.form"
                color="red"
                elevation="0"
                width="140"
                height="45"
                class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                style="font-weight: 600;">
              
                  Batal
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: {
          
        },
        category: [
          {
            title: 'Parsial',
            id: 'Parsial'
          },
          {
            title: 'Full',
            id: 'Full'
          }
        ],
        modal: false,
        menu2: false,

        dialog: {
          customer: false,
          fullscreen: false
        },
        bukti: 'gambar',
        gambar_url: '',
        pdf_url: '',
        category: ['Gambar', 'Pdf'],
        pembelian: [],
        product_id: '',
        selected: [],
        headers: [],
        list: [],
        supplier: [],
        form: {
          date: '',
          driver_id: '',
          note: '',
          vehicle_id: '',
          jumlah_bpb: '',
          order_id: '',
          // order_arr: [],
          varian_arr: [],
          // category: '',
          // image_url: '',
          // pdf_url: ''
        },
        order_json: [],
        vehicle: [],
        driver: [],
        order: [],
        headers_data: [],
        supervisor: [],
        branch: [],
        varian_arr: [],

        mobilephone: {
          name: '',
          id: ''
        },

        lastIndex: 1,

        upload: {
          pdf_url: null,
          image_url: null
        },

        process: {
          form: false,

          pdf_url: false,

          image_url: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue'),
      uploaddocument: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/document.vue')
    },
    watch: {
      'upload.pdf_url': {
        handler: function () {
          if (this.upload.pdf_url) {
            this.process.pdf_url = this.upload.pdf_url.process

            if (!this.process.pdf_url) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.pdf_url = this.upload.pdf_url.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      },

      'upload.image_url': {
        handler: function () {
          if (this.upload.image_url) {
            this.process.image_url = this.upload.image_url.process

            if (!this.process.image_url) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.gambar_url = this.upload.image_url.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      configHeaders () {
          return this.headers_data.filter(header => !header.hide)  
        },
    },
    mounted () {
      this.fetchVehicle()
      this.fetchOrder()
      this.fetchDriver()
    },
    methods: {
      async fetchOrder () {
        this.process.load = true

        let params = {
          limit: 1000000,
          status: 'persiapan',
          is_bpb: '0'
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/order/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.pembelian = res.results.data
            this.order = res.results.data
            
          }
          this.process.load = false
        })
      },
      async fetchVehicle () {
        this.process.load = true

        let params = {
          limit: 10000000,
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/vehicle/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.vehicle = res.results.data
            
          }
          this.process.load = false
        })
      },
      async fetchDriver () {
        this.process.load = true

        let params = {
          limit: 10000000,
          'category_user_id[eq]': '11',
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/user/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.driver = res.results.data
            
          }
          this.process.load = false
        })
      },
      addPcs(i, l){
        this.form.varian_arr[i].varian_arr[l].qty_pcs_approve
      },

      changeOrder() {
        // this.order_json = []
        this.order_json = this.order.find(x => x.id === this.form.order_id)
        // this.fetchDetailOrder(this.form.order_id)
        // for (let i = 0; i < this.form.order_arr.length; i++) {
        //   this.fetchDetailOrder(this.form.order_arr[i])
        // }
      },

      changeJumlah() {
        let data = []
        this.form.varian_arr = []
        for (let i = 0; i < this.form.jumlah_bpb; i++) {
          this.fetchDetailOrder(this.form.order_id, i+1)
          // data.push(
          //   {
          //     bpb_id: i+1,
          //     varian_arr: this.varian_arr
          //   }
          // )
        }

        // data.map((item) => {
        //   this.form.varian_arr.push({
        //     bpb_id: item.bpb_id,
        //     varian_arr: item.varian_arr
        //   })
        // })
      },

      async fetchDetailOrder (id, bpb_id) {
        let params = {
          id: id
        }

        await get('admin/order/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            // let data = []

            
            this.varian_arr = []
            res.results.data.detail.map((item) => {
             
              this.varian_arr.push({
                varian_id: item.detail_varian_id,
                varian_name: item.detail_varian_name,
                varian_sku: item.detail_varian_sku,
                qty_pcs_approve: 0,
                qty_lusin_approve: 0,
                qty_dus_approve: 0,
                qty_pcs_approve_warehouse: item.detail_qty_pcs_approved === undefined ? 0 : item.detail_qty_pcs_approved*1,
                qty_lusin_approve_warehouse: item.detail_qty_lusin_approved === undefined ? 0 : item.detail_qty_lusin_approved*1,
                qty_dus_approve_warehouse: item.detail_qty_dus_approved === undefined ? 0 : item.detail_qty_dus_approved*1,
                
              })
            })

            this.form.varian_arr.push(
              {
                bpb_id: bpb_id,
                varian_arr: this.varian_arr
              }
            )


            // this.changeJumlah()
            
              // this.order_json.push({
              //   ... res.results.data,
              //   varian_arr: [],
              //   order_id: id
                
              // })

            // this.order_json.map((items, index) => {
            //   this.order_json[index].varian_arr = []
            //   this.order_json[index].detail.map((item) => {
            //     this.order_json[index].varian_arr.push({
            //       varian_id: item.detail_varian_id,
            //       varian_name: item.detail_varian_name,
            //       varian_sku: item.detail_varian_sku,
            //       qty_pcs_approve: item.detail_qty_pcs_approved === undefined ? 0 : item.detail_qty_pcs_approved*1,
            //       qty_lusin_approve: item.detail_qty_lusin_approved === undefined ? 0 : item.detail_qty_lusin_approved*1,
            //       qty_dus_approve: item.detail_qty_dus_approved === undefined ? 0 : item.detail_qty_dus_approved*1,
            //       qty_pcs: 0,
            //       qty_lusin: 0,
            //       qty_dus: 0,
                  
            //     })
            //   })
            // })


          }
        })
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          // let varian_data = []
          // this.form.varian_arr.map((items, index) => {
          //   this.form.varian_arr[index].varian_arr.map((item) => {
          //     varian_data.push({
          //       var_arr: [
          //         {

          //           varian_id: item.varian_id,
          //           varian_name: item.varian_name,
          //           varian_sku: item.varian_sku,
          //           qty_pcs: item.qty_pcs,
          //           qty_lusin: item.qty_lusin,
          //           qty_dus: item.qty_dus,
          //         }
          //       ]
          //     })
          //   })
          // })
          let form = {
            order_id: this.form.order_id,
            jumlah_bpb: this.form.jumlah_bpb,
            // note: this.form.note,
            // vehicle_id: this.form.vehicle_id,
            // order_arr: JSON.stringify(this.order_json.map(item => {
            //   return {
            //     order_id: item.order_id,
                varian_arr: JSON.stringify(this.form.varian_arr.map(item => 

                  item.varian_arr
                
                )
                )
              // }
            // )),
          }
          this.process.form = true
          // console.log(varian_data)

          // SAVE TO REST API
          await post(`admin/bpb/add`, {
            data: form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              this.$router.push({ path: '/delivery/bpb' })

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>

<style >
table {
  border-collapse: collapse;
  width: 100%;
}

/* tr {
  border-bottom: 1px solid #ddd;
} */
</style>